import { Controller } from '@hotwired/stimulus'
import { useContactName } from './mixins/use_contact_name'

// Connects to data-controller="contacts--form"
export default class extends Controller {
  static targets = ['title', 'firstName', 'lastName']
  static values = {
    defaultTitle: String,
  }

  connect() {
    useContactName(this)
    this.updateTitle()
  }
}
